import { styled } from '../../providers/context/StyletronProvider/withStyletronProvider';

export const ModalWrapper = styled('div', () => ({}));
